import servers from './servers'

export default {
  [servers.user]: 'https://user-api.ecoach.evideo.tech',
  [servers.device]: 'https://api.ecoach.evideo.tech',
  [servers.platform]: 'https://platform-api.ecoach.evideo.tech'
}
